export default __webpack_public_path__ + "static/android-chrome-512x512-a5125d76c1635058834d64d52245ba9b.png";